import routes from 'src/router/routes';

export interface MenuIem {
  id: number;
  title: string;
  link: string;
}

const menuItems: MenuIem[] = [
  {
    id: 1,
    title: 'Mi Perfil',
    link: routes.profile,
  },
  {
    id: 2,
    title: 'Borradores',
    link: routes.drafts,
  },
  {
    id: 3,
    title: 'Salir de Medicloud',
    link: routes.logout,
  },
];

export default menuItems;
